import tippy from "tippy.js";
import {hideAll} from 'tippy.js';

export class OpenChatMessages {
    constructor(optionalOptions = {}) {
        this.allMessage = $(".chat--chat-message--body-one .chat--chat-message--body-one--title");

        if (!this.allMessage) {
            this.destructor();
            return true;
        }

        this.allMessage.each(function( index ) {
            let message = $(this)[0]
            let parentHasOther = $(this).closest('.chat--chat-message--body-one').hasClass('chat--chat-message--body-one--other')

            if (parentHasOther) {
                tippy(message, {
                    trigger: 'click',
                    placement: 'top-start',
                    fixed: true,
                    arrow: false,
                    hideOnClick: "toggle",
                    interactive: true,
                    content: document.getElementById("chat-message-actions").innerHTML,
                    allowHTML: true,
                    //appendTo: document.body,
                    onShown(instance) {
                    },
                    popperOptions: {
                        strategy: 'fixed',
                        modifiers: [
                            {
                                name: 'flip',
                                options: {
                                    allowedAutoPlacements: ['top', 'bottom'],
                                    rootBoundary: 'document',
                                    flipVariations: false,
                                    //fallbackPlacements: ['top', 'start'],
                                },
                            },
                        ]
                    },
                    onShow(instance) {
                        hideAll();
                    },
                });
            } else {
                tippy(message, {
                    trigger: 'click',
                    placement: 'top-start',
                    fixed: true,
                    arrow: false,
                    hideOnClick: "toggle",
                    interactive: true,
                    content: document.getElementById("chat-message-actions-sended").innerHTML,
                    allowHTML: true,
                    //appendTo: document.body,
                    popperOptions: {
                        strategy: 'fixed',
                        modifiers: [
                            {
                                name: 'flip',
                                options: {
                                    rootBoundary: 'document',
                                    allowedAutoPlacements: ['top', 'bottom'],
                                    flipVariations: false,
                                    //fallbackPlacements: ['top', 'start'],
                                },
                            }
                        ]
                    },
                    onShow(instance) {
                        hideAll();
                    },
                });
            }

            tippy(message, {
                trigger: 'click',
                placement: 'bottom-start',
                fixed: true,
                arrow: false,
                hideOnClick: "toggle",
                interactive: true,
                content: document.getElementById("chat-message-emotion").innerHTML,
                onShown(instance) {
                    setTimeout(() => { window.addLinksEmotion(); }, 500);
                    let parent;
                    let tippys;
                    const observer = new MutationObserver(() => {
                        // Выполните вашу функцию здесь
                        parent = $(instance.popper).closest('.chat--chat-message--body-one')
                        tippys = parent.find('[data-tippy-root]')

                        let result = window.changeTippyPositions(tippys);
                        if (!result) {
                            observer.disconnect();
                        }
                    });

                    observer.observe(instance.popper, {
                        attributes: true,
                        attributeFilter: ['style'],
                    });

                    parent = $(instance.popper).closest('.chat--chat-message--body-one')
                    tippys = parent.find('[data-tippy-root]')
                    window.changeTippyPositions(tippys);
                },
                //appendTo: document.body,
                popperOptions: {
                    strategy: 'fixed',
                    modifiers: [
                        {
                            name: 'flip',
                            options: {
                                rootBoundary: 'document',
                                allowedAutoPlacements: ['top', 'bottom'],
                                flipVariations: false,
                            },
                        },
                    ]
                },
                allowHTML: true,
            });
        });
    }

    destructor() {
        this.allMessage = null;
    }
}

export default new OpenChatMessages();